<script setup lang="ts">
import { ref, watch } from 'vue';
import { useItemsStore } from '../stores/items';

const items = useItemsStore();
const local = ref(items.filters.search);

// debounce 200ms — между набором символов и FTS5 запросом
let timer: ReturnType<typeof setTimeout> | null = null;
watch(local, (v) => {
  if (timer) clearTimeout(timer);
  timer = setTimeout(() => {
    items.filters.search = v;
  }, 200);
});

function clear() {
  local.value = '';
  items.filters.search = '';
}
</script>

<template>
  <div class="relative">
    <input
      v-model="local"
      type="search"
      enterkeyhint="search"
      autocomplete="off"
      autocorrect="off"
      autocapitalize="off"
      spellcheck="false"
      placeholder="Поиск по названию или описанию…"
      class="block w-full rounded-md border-0 bg-bg-card px-3 py-2 pr-9 text-base text-stone-200 placeholder:text-stone-500 focus:outline-none focus:ring-1 focus:ring-stone-500"
    />
    <button
      v-if="local"
      @click="clear"
      class="absolute right-1 top-1/2 -translate-y-1/2 rounded-md px-2 py-1 text-stone-400 hover:text-stone-200"
      aria-label="Очистить"
    >×</button>
  </div>
</template>
